import app from './app.js';

app(require('./router').default);
